import React, { useState, useRef } from 'react'

import HARDCODE from '../../../business-const/HardCode/HardCode'

import LABEL from '../../../business-const/Label/Label'

import LABELESPECIAL from '../../../business-const/Label/LabelEspecial'

import NUMMIN from '../../../business-rules/NumMinMax/NumMin'

import NUMMAX from '../../../business-rules/NumMinMax/NumMax'

import TAMMAX from '../../../business-rules/TamMax/TamMax'

import useSingleton from '../../../business-components/useSingleton/useSingleton'

import {
    GridContainer,
    GridItem3,
    GridItem6,
    GridItem12,
 } from '../../../business-components/Grid/Grid'

 import {
    CardGridEntradaDados,
    CardGridDivHeaderEntradaDados,
    CardGridDivEntradaDados,
    CardGridDivBody,
} from '../../../business-components/Card/Card'

import {
    TextValidatorText,
    TextValidatorNumber,
    TextValidatorValorRequired,
} from '../../../business-components/TextValidator/TextValidator'

import {
    ButtonGerarLancamentosPlanejamentoEspecializacaoPeriodoSabatico,
} from '../../../business-components/Button/Button'

import {
    processaCenariosDefaultJsonUsuario,
} from '../estudo-parametros/EstudoServiceCenarios'

import {
    inicializaEstudo,
    processaCalculoEstudo
} from './EstudoServiceCalculo'

import {
    informouPlanejamentoEspecializacaoPeriodoSabatico,
} from './EstudoServicoPlanejarEspecializacaoPeriodoSabatico'

import EstudoFormPlanejamentoEspecializacaoPeriodoSabaticoResumo from './EstudoFormPlanejamentoEspecializacaoPeriodoSabaticoResumo'



const EstudoFormPlanejamentoEspecializacaoPeriodoSabatico = ( { values, handleChange, handleSubmitAutomatico, jsonConfiguracao,
    jsonUsuario, jsonUsuarioAdmin } ) => {

    const [reexibir, setReexibir] = useState(false)

    const estudo = useRef(null)



    useSingleton(() => {

        values.planejamentoEspecializacaoPeriodoSabatico = null

        estudo.current = inicializaEstudo(/*jsonConfiguracao*/)

        processaCenariosDefaultJsonUsuario(values, jsonUsuario, jsonUsuarioAdmin)
    })



    return (
        reexibir || !reexibir
            ?
                <GridContainer>
                    <GridItem12>
                        <CardGridEntradaDados>
                            <GridItem12>
                                <CardGridDivHeaderEntradaDados>
                                    <CardGridDivEntradaDados>
                                        {LABEL.planejamentoEspecializacaoPeriodoSabatico}
                                    </CardGridDivEntradaDados>
                                </CardGridDivHeaderEntradaDados>

                                <CardGridDivBody>
                                    <GridContainer>
                                        <GridItem12>
                                            <TextValidatorText
                                                name={"descricaoEspecializacaoPeriodoSabatico"}
                                                label={LABEL.descricao}
                                                value={values.descricaoEspecializacaoPeriodoSabatico || ''}
                                                onChange={handleChange}
                                                tamMax={TAMMAX.descricaoEspecializacaoPeriodoSabatico}
                                                notToUpperCase={true}
                                            />
                                        </GridItem12>
                                    </GridContainer>
                                </CardGridDivBody>
                            </GridItem12>

                            <GridItem12>
                                <CardGridDivHeaderEntradaDados>
                                    <CardGridDivEntradaDados>
                                        {LABEL.antesEspecializacaoPeriodoSabatico}
                                    </CardGridDivEntradaDados>
                                </CardGridDivHeaderEntradaDados>

                                <CardGridDivBody>
                                    <GridContainer>
                                        <GridItem6>
                                            <TextValidatorValorRequired
                                                name={"valorReceitaMensalAntesEspecializacaoPeriodoSabatico"}
                                                label={LABEL.receitaMensal}
                                                value={values.valorReceitaMensalAntesEspecializacaoPeriodoSabatico || ''}
                                                onChange={handleChange}
                                            />
                                        </GridItem6>
                                        <GridItem6>
                                            <TextValidatorValorRequired
                                                name={"valorDiaDiaAntesEspecializacaoPeriodoSabatico"}
                                                label={LABEL.diaDia}
                                                value={values.valorDiaDiaAntesEspecializacaoPeriodoSabatico || ''}
                                                onChange={handleChange}
                                            />
                                        </GridItem6>
                                    </GridContainer>
                                </CardGridDivBody>
                            </GridItem12>

                            <GridItem12>
                                <CardGridDivHeaderEntradaDados>
                                    <CardGridDivEntradaDados>
                                        {LABEL.duranteEspecializacaoPeriodoSabatico}
                                    </CardGridDivEntradaDados>
                                </CardGridDivHeaderEntradaDados>

                                <CardGridDivBody>
                                    <GridContainer>
                                        <GridItem6>
                                            <TextValidatorValorRequired
                                                name={"valorReceitaMensalDuranteEspecializacaoPeriodoSabatico"}
                                                label={LABEL.receitaMensal}
                                                value={values.valorReceitaMensalDuranteEspecializacaoPeriodoSabatico || ''}
                                                onChange={handleChange}
                                            />
                                        </GridItem6>
                                        <GridItem6>
                                            <TextValidatorValorRequired
                                                name={"valorDiaDiaDuranteEspecializacaoPeriodoSabatico"}
                                                label={LABEL.diaDia}
                                                value={values.valorDiaDiaDuranteEspecializacaoPeriodoSabatico || ''}
                                                onChange={handleChange}
                                            />
                                        </GridItem6>
                                    </GridContainer>
                                    <GridContainer>
                                        <GridItem3>
                                            <TextValidatorNumber
                                                name="mesesEspecializacaoPeriodoSabatico"
                                                label={LABELESPECIAL.meses}
                                                value={values.mesesEspecializacaoPeriodoSabatico === 0 ? 0 : values.mesesEspecializacaoPeriodoSabatico || ''}
                                                onChange={handleChange}
                                                numMin={NUMMIN.meses}
                                                numMax={NUMMAX.meses}
                                            />
                                        </GridItem3>
                                    </GridContainer>
                                </CardGridDivBody>
                            </GridItem12>
                        
                            <GridItem12>
                                <CardGridDivHeaderEntradaDados>
                                    <CardGridDivEntradaDados>
                                        {LABEL.depoisEspecializacaoPeriodoSabatico}
                                    </CardGridDivEntradaDados>
                                </CardGridDivHeaderEntradaDados>

                                <CardGridDivBody>
                                    <GridContainer>
                                        <GridItem6>
                                            <TextValidatorValorRequired
                                                name={"valorReceitaMensalDepoisEspecializacaoPeriodoSabatico"}
                                                label={LABEL.receitaMensal}
                                                value={values.valorReceitaMensalDepoisEspecializacaoPeriodoSabatico || ''}
                                                onChange={handleChange}
                                            />
                                        </GridItem6>
                                        <GridItem6>
                                            <TextValidatorValorRequired
                                                name={"valorDiaDiaDepoisEspecializacaoPeriodoSabatico"}
                                                label={LABEL.diaDia}
                                                value={values.valorDiaDiaDepoisEspecializacaoPeriodoSabatico || ''}
                                                onChange={handleChange}
                                            />
                                        </GridItem6>
                                    </GridContainer>
                                </CardGridDivBody>
                            </GridItem12>

                            <GridItem12
                                className='mt-5 mb-7'
                            >
                                <ButtonGerarLancamentosPlanejamentoEspecializacaoPeriodoSabatico
                                    onClick={() => {
                                        //gerarLancamentosPlanejamentoEspecializacaoPeriodoSabatico(values)
                                        processaCalculoEstudo(values, handleSubmitAutomatico, estudo, false, true,
                                            HARDCODE.origemCalculoEstudoPlanejamentoEspecializacaoPeriodoSabatico,
                                                /*true*/false, jsonConfiguracao, false)
                                        setReexibir(!reexibir)
                                    }}
                                    disabled={!informouPlanejamentoEspecializacaoPeriodoSabatico(values)}
                                />
                            </GridItem12>
                            
                            {values.planejamentoEspecializacaoPeriodoSabatico && (
                                <GridItem12>
                                    <CardGridDivHeaderEntradaDados>
                                        <CardGridDivEntradaDados>
                                            {LABEL.planejamento + ' ' +
                                                values.planejamentoEspecializacaoPeriodoSabatico.descricaoEspecializacaoPeriodoSabatico
                                            }
                                        </CardGridDivEntradaDados>
                                    </CardGridDivHeaderEntradaDados>

                                    <CardGridDivBody>
                                        <GridContainer>
                                            <GridItem12>
                                                <EstudoFormPlanejamentoEspecializacaoPeriodoSabaticoResumo
                                                    values={values}
                                                    estudo={estudo}
                                                />
                                            </GridItem12>
                                        </GridContainer>
                                    </CardGridDivBody>
                                </GridItem12>
                            )}
                        </CardGridEntradaDados>
                    </GridItem12>
                </GridContainer>
            :
                ''
    )
}

export default EstudoFormPlanejamentoEspecializacaoPeriodoSabatico